module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ScheduleView.js"));
	}, "ScheduleView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ScheduleView!./src/pages/Promote/Schedule/ScheduleView.js
// module id = 2091
// module chunks = 367